// extracted by mini-css-extract-plugin
module.exports =  {"campaignSummary":"eer0CAH1dgve42ZLGYbd"};